// extracted by mini-css-extract-plugin
export default {"cropperFrame":"ImageFramingStage_cropperFrame__thvR5"};